import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-bottom1",
  "use": "icon-arrow-bottom1-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-bottom1\">\n<path d=\"M12.7955 6.19456C12.7955 6.36583 12.7269 6.53711 12.5899 6.67413L8.47935 10.7847C8.20531 11.0587 7.79425 11.0587 7.52021 10.7847L3.40963 6.67413C3.13559 6.40009 3.13559 5.98903 3.40963 5.71499C3.68367 5.44095 4.09473 5.44095 4.36877 5.71499L7.99978 9.346L11.6308 5.71499C11.9048 5.44095 12.3159 5.44095 12.5899 5.71499C12.7269 5.85201 12.7955 6.02328 12.7955 6.19456Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol